import React, { useState, useEffect } from 'react';
import { Check, X } from 'lucide-react';

const RULES = [
  { id: 'length', label: 'Mínimo de 8 caracteres', test: (p) => p.length >= 8 },
  { id: 'upper', label: '1 letra maiúscula', test: (p) => /[A-Z]/.test(p) },
  { id: 'lower', label: '1 letra minúscula', test: (p) => /[a-z]/.test(p) },
  { id: 'digit', label: '1 número', test: (p) => /\d/.test(p) },
  { id: 'special', label: '1 caractere especial', test: (p) => /[!@#$%^&*()_+\-=[\]{}|;':",.<>?/\\`~]/.test(p) },
];

export default function PasswordStrength({ password = '', onChange }) {
  const [results, setResults] = useState(RULES.map(r => ({ ...r, passed: false })));

  useEffect(() => {
    setResults(RULES.map(r => ({ ...r, passed: r.test(password) })));
  }, [password]);

  const passed = results.filter(r => r.passed).length;
  const total = results.length;
  const percent = total > 0 ? (passed / total) * 100 : 0;

  const barColor = percent <= 20 ? 'bg-red-500' : percent <= 60 ? 'bg-orange-500' : percent <= 80 ? 'bg-amber-500' : 'bg-emerald-500';
  const label = percent <= 20 ? 'Muito fraca' : percent <= 40 ? 'Fraca' : percent <= 60 ? 'Média' : percent <= 80 ? 'Boa' : 'Forte';

  if (!password) return null;

  return (
    <div className="space-y-2 mt-2" data-testid="password-strength">
      {/* Strength bar */}
      <div className="flex items-center gap-2">
        <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-300 ${barColor}`}
            style={{ width: `${percent}%` }}
          />
        </div>
        <span className={`text-[10px] font-medium ${barColor.replace('bg-', 'text-')}`}>{label}</span>
      </div>

      {/* Rules checklist */}
      <div className="grid grid-cols-2 gap-1">
        {results.map(rule => (
          <div key={rule.id} className="flex items-center gap-1.5">
            {rule.passed ? (
              <Check className="w-3 h-3 text-emerald-500" />
            ) : (
              <X className="w-3 h-3 text-red-400" />
            )}
            <span className={`text-[10px] ${rule.passed ? 'text-emerald-600' : 'text-muted-foreground'}`}>
              {rule.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function isPasswordStrong(password) {
  return RULES.every(r => r.test(password));
}
